import React from "react";
import axios from "axios";
import history from "../../auth/history";
import { connect } from "react-redux";
import moment from "moment";
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import './Calendar.css';
import { store } from "../../redux/store";
import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";
import { selectDueDate, selectedConsumerList, setEndDate, setSelectedAmount, setStartDate } from "../../redux/misc-data/misc-data.action";
const httpClient = axios.create();

class CalendarGraph extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            initialDate: '',
            eventList: [],
            catValues: [
                { value: "Select", label: "Select" },
                { value: "Week", label: "Week" },
                { value: "Month", label: "Month" },
            ],
            view: 'dayGridMonth',
            toolbarInput: {
                center: 'title',
                // right: 'dayGridMonth,dayGridWeek',
                start: "today prev next",
                end: "dayGridMonth",


                //onclick:this.test()

            }
        }
    }
    view = 'dayGridMonth';

    test = (dateInfo, end, start) => {

        // alert(JSON.stringify(dateInfo))
        if (dateInfo.view.type == "dayGridDay") {

        } else {
            var val = (moment(end).format('YYYY-MM-DD HH:mm:ss'))
            var date = new Date(val);
            // var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth(), 0);
            var lastDayVal = moment(lastDay).format('YYYY-MM-DD');
            store.dispatch(setEndDate(lastDayVal));
            // alert('lastday:'+(moment(lastDay).format('YYYY-MM-DD')))
            var val1 = (moment(start).format('YYYY-MM-DD HH:mm:ss'))
            var date1 = new Date(val1);
            var firstDay = new Date(date1.getFullYear(), date1.getMonth() + 1, 0);
            var firstDayVal = moment(firstDay).format('YYYY-MM-DD')
            store.dispatch(setStartDate(firstDayVal));

            this.loadAllConsumerWithStartAndEndDte(firstDayVal, lastDayVal);
        }



    }

    loadAllConsumerWithStartAndEndDte(firstDayVal, lastDayVal) {
        store.dispatch(selectedConsumerList([]))
        store.dispatch(setSelectedAmount(0));
        
        var eventList = [];

        var eventCountMap = new Map();
        var totalAmountMap = new Map();
        var url = '/api/v1/billpay/corp/consumer/get-list/';
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo,
            'role': this.props.clientRole
        }


        httpClient.get(url + this.props.agentInfo + '/' + firstDayVal + '/' + lastDayVal,
            { headers }
        ).then((response) => {
            var totalAmount = 0;
            var consumerList = [];
            if (response.data != undefined) {
                if (response.data.length > 0) {

                    response.data.map(res => {

                        if (res.lastKnownStatus == "BILL_FETCH_SUCCESS"
                            || res.lastKnownStatus == "CREATE_ORDER_FAILED"
                            || res.lastKnownStatus == "BILL_PAY_FAILED") {
                            var dateVal = "";


                            if (res.currentBillPayAmount != undefined &&
                                res.currentBillPayAmount != null &&
                                res.currentBillPayAmount != 'null' &&
                                res.currentBillPayAmount != '' &&
                                res.currentBillPayAmount > 0
                            ) {

                                consumerList.push(res);
                                totalAmount = totalAmount + res.currentBillPayAmount;
                                setTimeout(() => {
                                    store.dispatch(setSelectedAmount(totalAmount));
                                    store.dispatch(selectedConsumerList(consumerList));
                                }, 400);
                               
                            } else {

                            }

                            if (res.lastBillFetch != undefined &&
                                res.lastBillFetch.dueDate != null &&
                                res.currentBillPayAmount != undefined &&
                                res.currentBillPayAmount != null &&
                                res.currentBillPayAmount != '' &&
                                res.currentBillPayAmount > 0) {
                                var dueDate = res.lastBillFetch.dueDate;
                                if (dueDate.includes("/")) {
                                    var arr = dueDate.split("/");
                                    dateVal = arr[2] + "-" + arr[1] + "-" + arr[0];
                                    if (eventCountMap.get(dateVal) == undefined) {
                                        eventCountMap.set(dateVal, 1)
                                    } else {
                                        eventCountMap.set(dateVal, eventCountMap.get(dateVal) + 1)
                                    }

                                    if (res.currentBillPayAmount != undefined &&
                                        res.currentBillPayAmount != null &&
                                        res.currentBillPayAmount != '' &&
                                        res.currentBillPayAmount > 0) {

                                        if (totalAmountMap.get(dateVal) == undefined) {
                                            totalAmountMap.set(dateVal, res.currentBillPayAmount)
                                        } else {

                                            totalAmountMap.set(dateVal,
                                            totalAmountMap.get(dateVal) + res.currentBillPayAmount)
                                        }
                                    }
                                }
                            }
                        }


                    })
                }
            }

            if (eventCountMap != undefined) {
                let keys = [...eventCountMap.keys()];
                if (keys.length > 0) {
                    keys.map(key => {
                        var event1 = {
                            title: "Bill Count:" + eventCountMap.get(key),
                            start: key,
                            end: key,
                            color: '#df4e27',
                            url: '/bill-list',
                            durationEditable: true

                        }
                        eventList.push(event1);
                    })
                }
            }
            if (totalAmountMap != undefined) {
                let keys = [...totalAmountMap.keys()];
                if (keys.length > 0) {
                    keys.map(key => {
                        var event = {
                            title: parseFloat(totalAmountMap.get(key)).toFixed(2).toLocaleString("en-US"),
                            start: key,
                            end: key,
                            color: '#ff9000',
                            url: '/bill-list',
                            durationEditable: true

                        }
                        eventList.push(event);
                    })
                }
            }

            setTimeout(() => {
                this.setState({
                    eventList: eventList
                })
               
            }, 400);


        }).catch(error => {


            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }

        });


    }
    // componentDidMount() {
    //     var yourDate = new Date();
    //     yourDate = yourDate.toISOString().split('T')[0];
    //     store.dispatch(selectDueDate(''));
    //     this.setState({
    //         initialDate: yourDate
    //     })
    //     var eventList = [];

    //     var eventCountMap = new Map();
    //     var totalAmountMap = new Map();

    //     if (this.props.consumerList != undefined &&
    //         this.props.consumerList.length > 0) {
    //         this.props.consumerList.map(consumer => {

    //             var dateVal = "";

    //             if (consumer.lastKnownStatus == "BILL_FETCH_SUCCESS"
    //                 || consumer.lastKnownStatus == "CREATE_ORDER_FAILED"
    //                 || consumer.lastKnownStatus == "BILL_PAY_FAILED") {
    //             }

    //             if (consumer.lastBillFetch != null &&
    //                 consumer.lastBillFetch.dueDate != undefined) {
    //                 var dueDate = consumer.lastBillFetch.dueDate;
    //                 if (dueDate.includes("/")) {
    //                     var arr = dueDate.split("/");
    //                     dateVal = arr[2] + "-" + arr[1] + "-" + arr[0];
    //                     if (eventCountMap.get(dateVal) == undefined) {
    //                         eventCountMap.set(dateVal, 1)
    //                     } else {
    //                         eventCountMap.set(dateVal, eventCountMap.get(dateVal) + 1)
    //                     }


    //                     if (consumer.currentBillPayAmount != undefined) {

    //                         if (totalAmountMap.get(dateVal) == undefined) {
    //                             totalAmountMap.set(dateVal, consumer.currentBillPayAmount)
    //                         } else {

    //                             totalAmountMap.set(dateVal,
    //                                 totalAmountMap.get(dateVal) + consumer.currentBillPayAmount)
    //                         }
    //                     }
    //                 }
    //             }
    //         })


    //         if (eventCountMap != undefined) {
    //             let keys = [...eventCountMap.keys()];
    //             if (keys.length > 0) {
    //                 keys.map(key => {
    //                     var event1 = {
    //                         title: "Bill Count:" + eventCountMap.get(key),
    //                         start: key,
    //                         end: key,
    //                         color: '#df4e27',
    //                         url: '/bill-list',
    //                         durationEditable: true

    //                     }
    //                     eventList.push(event1);
    //                 })
    //             }
    //         }
    //         if (totalAmountMap != undefined) {
    //             let keys = [...totalAmountMap.keys()];
    //             if (keys.length > 0) {
    //                 keys.map(key => {
    //                     var event = {
    //                         title: parseFloat(totalAmountMap.get(key)).toFixed(2),
    //                         start: key,
    //                         end: key,
    //                         color: '#df4e27',
    //                         url: '/bill-list',
    //                         durationEditable: true

    //                     }
    //                     eventList.push(event);
    //                 })
    //             }
    //         }
    //         this.setState({
    //             eventList: eventList
    //         })

    //     }
    // }
    componentWillUnmount() {
    }
    alertEventClick = (info) => {
        info.jsEvent.preventDefault(); // don't let the browser navigate
        var consumerList = [];
        var totalAmount = 0;

        store.dispatch(setStartDate(moment(info.event.start).format('YYYY-MM-DD')));
        store.dispatch(setEndDate(moment(info.event.start).format('YYYY-MM-DD')));

        setTimeout(() => {
            var goToBillList = document.getElementById('goToBillList');
            goToBillList.click();
        }, 100);


    }

    render() {



        return (

            <div class="dashclndr">
                <Link to='/bill-list'>
                    <button id="goToBillList" hidden={true}>
                    </button>
                </Link>
                <div id="calendar">

                    <FullCalendar
                        aspectRatio='2.2'
                        headerToolbar={this.state.toolbarInput}
                        datesSet={(dateInfo) => {
                            this.test(dateInfo, dateInfo.end, dateInfo.start)
                        }}
                        navLinks='true' // can click day/week names to navigate views
                        businessHours='true' // display business hours
                        editable='true'
                        selectable='true'
                        displayEventTime='true'
                        plugins={[dayGridPlugin]}
                        initialDate={this.state.initialDate != '' ? this.state.initialDate : new Date().toISOString().split('T')[0]}
                        initialView={'dayGridMonth'}
                        weekends={true}
                        eventClick={this.alertEventClick}
                        disableResizing={false}
                        views={["title dayGridMonth", "dayGridWeek", "dayGridDay"]}

                        // events={[{
                        //     title: 'Bill count: 3',
                        //     start: '2023-02-09',
                        //     end: '2023-02-09',
                        //     color: '#df4e27',
                        //     amount: '2000',
                        //     url: '/bill-list',
                        // },
                        // {
                        //     title: '₹5920.00',
                        //     start: '2023-02-09',
                        //     end: '2023-02-09',
                        //     color: '#df4e27',
                        //     url: '/bill-list',
                        // },
                        // {
                        //     title: 'Bill count: 5',
                        //     start: '2023-02-09',
                        //     end: '2023-02-09',
                        //     color: '#df4e27',
                        //     url: '/bill-list',
                        // },
                        // {
                        //     title: '₹2970.00',
                        //     start: '2023-01-09',
                        //     end: '2023-01-09',
                        //     color: '#df4e27',
                        //     url: '/bill-list',
                        // },

                        // {
                        //     title: 'Bill count: 8',
                        //     start: '2023-02-09',
                        //     end: '2023-02-09',
                        //     color: '#df4e27',
                        //     url: '/bill-list',
                        // },
                        // {
                        //     title: '₹12984.00',
                        //     start: '2023-02-09',
                        //     end: '2023-02-09',
                        //     color: '#df4e27',
                        //     url: '/bill-list',
                        // },
                        // {
                        //     title: 'Bill count: 26',
                        //     start: '2023-02-09',
                        //     end: '2023-02-09',
                        //     color: '#ff9000 ',
                        //     url: '/bill-list',
                        // },
                        // {
                        //     title: '₹36984.00',
                        //     start: '2023-01-09',
                        //     end: '2023-01-09',
                        //     color: '#ff9000 ',
                        //     url: '/bill-list',
                        // },

                        // {
                        //     title: 'Bill count: 56',
                        //     start: '2023-01-09',
                        //     end: '2023-01-09',
                        //     color: '#009adb ',
                        //     url: '/bill-list',
                        // },
                        // {
                        //     title: '₹36984.00',
                        //     start: '2023-01-09',
                        //     end: '2023-01-09',
                        //     color: '#009adb ',
                        //     url: '/bill-list',
                        // },

                        // {
                        //     title: 'Bill count: 43',
                        //     start: '2023-01-09',
                        //     end: '2023-01-09',
                        //     color: '#009adb ',
                        //     url: '/bill-list',
                        // },
                        // {
                        //     title: '₹36984.00',
                        //     start: '2023-01-09',
                        //     end: '2023-01-09',
                        //     color: '#009adb ',
                        //     url: '/bill-list',
                        // },]}
                        events={this.state.eventList}
                    />

                </div>
            </div>

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, },
        miscReduce: { phone, agentInfo, clientRole, token } }
) => ({
    errorMessage, phone, agentInfo, clientRole, token
});

export default connect(mapStateToProps, null)(CalendarGraph);
